"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const Box_1 = require("./Box");
exports.List = Box_1.Box.withComponent('ul');

//# sourceMappingURL=List.js.map
